import { Folders } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const FoldersIcon = createLucideIcon(Folders);
